import React from "react";
import {
  Container,
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import { Link } from 'react-router-dom';
import parseBlogContent from './parseBlogContent';
import blog3 from "../../assests/blog3.jpeg";
import { useTranslation } from "react-i18next";

const Blog3 = () => {
  const { t, i18n } = useTranslation();

  // Helper function to safely render HTML content within Typography
  const renderHTML = (key, props = {}) => {
    return (
      <Typography
        component="div"
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3 }}
        {...props}
      >
        {parseBlogContent(t(key), i18n.language)}
      </Typography>
    );
  };

  return (
    <Container component="article" maxWidth="md" sx={{ p: 0 }}>
      <Box sx={{ my: 10 }}>
        <Card sx={{ backgroundColor: "transparent", p: { xs: 1, md: 5 } }}>
          <Typography
            variant="h1"
            sx={{
              mb: 5,
              color: "black",
              fontSize: { xs: "1.75rem", sm: "2.25rem" },
            }}
          >
            {t("title3")}
          </Typography>
          <CardMedia
            component="img"
            image={blog3}
            alt={t("Logo Design")}
            sx={{ height: "auto", width: "100%", mb: 5 }}
          />
          <CardContent>
            {renderHTML("description3")}
            {renderHTML("stage1")}
            {renderHTML("stage1Description")}
            {renderHTML("stage2")}
            {renderHTML("stage2Description")}
            {renderHTML("stage3")}
            {renderHTML("stage3Description")}
            {renderHTML("stage4")}
            {renderHTML("stage4Description")}
            {renderHTML("stage5")}
            {renderHTML("stage5Description")}
            {renderHTML("stage6")}
            {renderHTML("stage6Description")}
            {renderHTML("subDescription39")}
            {renderHTML("subDescription40")}
            {renderHTML("subDescription41")}
            {renderHTML("subDescription42")}
            {renderHTML("subDescription43")}
            {renderHTML("subDescription44")}
            {renderHTML("subDescription45")}
            <Typography variant="body1" sx={{ color: "blue" }}>
              {t("Email")}:{" "}
              <a
                href="mailto:info@thas-multitech.com"
                style={{ color: "#146b65" }}
              >
                info@thas-multitech.com
              </a>
            </Typography>
            <Typography variant="body1" sx={{ color: "blue" }}>
              {t("Website")}:{" "}
              <Link
                to="/"
                style={{ color: "#146b65" }}
              >
                www.thas-multitech.com
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Blog3;
